import { useQuery } from "@tanstack/react-query"; // falls du „react-query“ V3 nutzt → anpassen
import { core } from "@tauri-apps/api";

import { type Roadmap_Item } from "@/domains/admin/roadmap/types/roadmap-types";

/* ------------------------------------------------------------ */
/* Fetcher                                                      */
/* ------------------------------------------------------------ */

const fetchRoadmapItems = async (): Promise<Roadmap_Item[]> => {
  // Der Command-Name muss exakt mit deinem Rust-Command übereinstimmen
  // (fetch_roadmap_items in commands.rs)
  return await core.invoke<Roadmap_Item[]>("fetch_roadmap_items");
};

/* ------------------------------------------------------------ */
/* Hook                                                         */
/* ------------------------------------------------------------ */

export const useRoadmapItems = () => {
  return useQuery({
    queryFn: fetchRoadmapItems,
    queryKey: ["roadmapItems"],
    staleTime: 60_000, // 1 Minute Cache
  });
};
